/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable max-len */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, Form, Radio, Row, Space } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { ILeiDetailData, ILeiDetailEvent, ILeiOtherEntityNames, ILeiRejstrikResp, ILeiSubory } from 'types/leiTypes';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputTextArea from 'components/atoms/InputTextArea';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import UploadComponent, { IFileList } from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import { getPrehledFields } from 'components/pages/Lei/formularPages/PrehledPages/DetailInfoPrehled';

import { IcisStaty } from 'services/cisStaty';
import fileDownload from 'services/fileDownload';
import checkLeiApi from 'services/lei/checkLEI';
import prepareFile from 'services/lei/fileDownload';

import { ETypZadostiLei } from 'enums/lei/leiDataEnums';
import { EEventStatus, EEventType } from 'enums/lei/leiDetailDataEnums';
import { EJinyTyp } from 'enums/lei/leiJinyTypEnums';
import { ETypAdresy } from 'enums/lei/typAdresy';
import { ENotificationType } from 'enums/notificationType';

import { leiJazykySelect } from 'data/codebooks/lei/jazykySelect';
import { leiCountryRegionSelect } from 'data/codebooks/lei/leiCountryRegion';
import { leiDetailZmenaSelect, leiZmenaStav } from 'data/codebooks/lei/leiDetailZmenaSelect';
import { leiElfKodyPermanent, leiElfKodySelect } from 'data/codebooks/lei/leiElfKodySelect';
import { leiTypNazvuSelect } from 'data/codebooks/lei/leiTypNazvuSelect';
import {
    leiJinyBranch,
    leiJinyFund,
    leiJinyGeneral,
    leiJinyGovermentEntity
} from 'data/codebooks/lei/leiZmenaJinyTypSelect';

import { _getKeyValue_ } from 'utils/getObjectKeyValue';
import leiValidation from 'utils/validations/leiValidation';
import pscValidation from 'utils/validations/pscValidation';

import { IRejstrikErrs } from './UpravaLei';

interface IUpravaLeiDetail {
    setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
    setFormData: React.Dispatch<React.SetStateAction<ILeiDetailData | undefined>>;
    formData: ILeiDetailData | undefined;
    setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
    nextStep?: () => void;
    prevStep?: () => void;
    isPrehled?: boolean;
    cisStaty: IcisStaty[] | [];
    rejstrikVals?: ILeiRejstrikResp;
    rejstrikErrs?: IRejstrikErrs;
    PrehledOnly?: boolean;
}

const UpravaLeiDetail: React.FC<IUpravaLeiDetail> = ({
    setFormData,
    formData,
    setCurrentStep,
    setIsEdit,
    nextStep,
    prevStep,
    isPrehled,
    cisStaty,
    rejstrikVals,
    // rejstrikErrs,
    PrehledOnly
}) => {
    const { lei, NotificationComponent, language } = useContext(Context);
    const [form] = Form.useForm();
    const [radioSubEventType, setRadioSubEvenType] = useState<EJinyTyp>();
    const [radioEventType, setRadioEventype] = useState<EEventType>();
    const [disableDownload, setDisableDownload] = useState<boolean>(false);
    const [leiDataFiltered, setLeiDataFiltered] = useState<any>([]);
    const [failedSouborValidations, setFailedSouborValidations] = useState<number[]>([]);
    const [leiCheckLoading, setLeiCheckLoading] = useState<boolean>(false);
    const [leiCheckError, setLeiCheckError] = useState<string>('');
    const [openModal, setOpenModal] = useState<'name' | 'ico' | ''>('');
    const [currentEvents, setCurrentEvents] = useState<ILeiDetailEvent[] | undefined>(formData?.events);
    const [selectedEvent, setSelectedEvent] = useState<ILeiDetailEvent>();
    const [selectedEventIndex, setSelectedEventIndex] = useState<number>();
    const [showDefaultValues, setShowDefaultValues] = useState<{
        region: boolean;
        hqregion: boolean;
    }>({
        region: true,
        hqregion: true
    });
    const [fileList, setFileList] = useState<IFileList[]>([]);
    const [prilozeneSoubory, setPrilozeneSoubory] = useState<ILeiSubory[]>([]);
    const [sameValsErr, setSameValsErr] = useState<boolean>(false);
    const [otherEntityNames, setOtherEntityNames] = useState<ILeiOtherEntityNames[] | undefined>([{}]);
    const [uploading, setUploading] = useState<boolean>(false);
    const prehledFields = getPrehledFields(formData?.spolecnost, language, formData?.typzadosti);

    const LEGALADDRESSALTERNATIVE =
        formData?.spolecnost?.adresy &&
        formData.spolecnost.adresy.filter(e => e.typadresy === ETypAdresy.LEGALADDRESSALTERNATIVE);
    const LEGALADDRESS =
        formData?.spolecnost?.adresy && formData.spolecnost.adresy.filter(e => e.typadresy === ETypAdresy.LEGALADDRESS);
    const HQADDRESS =
        formData?.spolecnost?.adresy &&
        formData.spolecnost.adresy.filter(e => e.typadresy === ETypAdresy.HEADQUARTERSADDRES);
    const HQTRANSALT =
        formData?.spolecnost?.adresy &&
        formData.spolecnost.adresy.filter(e => e.typadresy === ETypAdresy.HQTRANSALTERNATIVE);

    const setForceRerender = useState<boolean>(false)[1];
    const rerender = () => {
        setForceRerender(val => !val);
    };

    const validateFiles = () => {
        const failedValidation: number[] = [];
        formData?.events?.map(
            (e, i) =>
                e.idzadosti === lei?.idVarsymZadosti?.id &&
                e.soubory &&
                e.soubory?.length < 1 &&
                e.eventtype !== EEventType.VZNIKSPOLECNOSTI &&
                failedValidation.push(i)
        );
        setFailedSouborValidations(failedValidation);
    };

    useEffect(() => {
        // odstrani hodnotu zo selectu (po pridani poli pre zmenu)%
        const filtered = leiDetailZmenaSelect.filter(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e: any) =>
                (formData?.events || [])?.filter(u => u.eventtype === e.value).length < 1 &&
                (e.value === EEventType.VZNIKSPOLECNOSTI ? !formData?.spolecnost?.entitycreationddate : true) &&
                (e.value === EEventType.CHANGE_OTHER_NAMES
                    ? !(
                          formData?.typzadosti === ETypZadostiLei.BRANCH ||
                          formData?.typzadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                      )
                    : true)
        );
        setLeiDataFiltered(filtered);
        form.setFieldsValue({
            zmena: undefined
        });
        setCurrentEvents(formData?.events);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData?.events]);

    useEffect(() => {
        (openModal || selectedEvent) && setTimeout(() => rerender(), 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, selectedEvent]);

    useEffect(() => {
        validateFiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    useEffect(() => {
        selectedEvent &&
            selectedEvent.soubory &&
            setFileList(
                selectedEvent.soubory.map((e, i) => {
                    return {
                        uid: String(i),
                        name: e.orignazev ? e.orignazev : 'bez nazvu',
                        fileName: e.tempnazev ? e.tempnazev : 'a',
                        type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                        size: 0,
                        status: 'done'
                    };
                })
            );
        selectedEvent && selectedEvent.soubory && setPrilozeneSoubory(selectedEvent.soubory);
        setOtherEntityNames([...(selectedEvent?.hlasenyzmeny?.spolecnost?.otherentitynames || []), {}]);
        form.resetFields();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEvent, selectedEventIndex]);

    const formatPSC = (psc: string, country: string) => {
        if (country === 'CZ' || country === 'SK') {
            const splitVal = psc.replace(/\s/g, '').split('');
            splitVal.length > 3 && splitVal[3] !== ' ' && splitVal.splice(3, 0, ' ');
            const formatedPsc = splitVal.length > 3 ? splitVal.join('') : psc;
            return formatedPsc;
        }
        return psc;
    };

    const formDataSetters = {
        VZNIKSPOLECNOSTI: (fieldsValue: any) => {
            return {
                spolecnost: {
                    entitycreationddate: fieldsValue.entitycreationddate
                        ? fieldsValue.entitycreationddate.format('YYYY-MM-DD')
                        : undefined
                }
            };
        },
        CHANGE_LEGAL_NAME: (fieldsValue: any) => {
            return {
                spolecnost: {
                    legalname: fieldsValue.legalname
                }
            };
        },
        CHANGE_OTHER_NAMES: () => {
            return {
                spolecnost: {
                    ...(otherEntityNames?.length && {
                        otherentitynames: otherEntityNames?.filter(e => e.otherentityname)
                    })
                }
            };
        },
        CHANGE_LEGAL_FORM: (fieldsValue: any) => {
            return {
                spolecnost: {
                    entitylegalformcode: fieldsValue.entitylegalformcode,
                    otherlegalform: fieldsValue.otherlegalform
                }
            };
        },
        OSTATNI: (fieldsValue: any) => {
            return {
                ...(fieldsValue?.popis && {
                    popis: fieldsValue?.popis
                }),
                ...(fieldsValue?.successorentitylei && {
                    successorentitylei: fieldsValue?.successorentitylei
                }),
                ...(fieldsValue?.successorentityname &&
                    !fieldsValue?.successorentitylei && {
                        successorentityname: fieldsValue?.successorentityname
                    })
            };
        },
        CHANGE_LEGAL_ADDRESS: (fieldsValue: any, hqCopy?: boolean) => {
            return {
                spolecnost: {
                    adresy: [
                        {
                            typadresy: hqCopy ? ETypAdresy.HEADQUARTERSADDRES : ETypAdresy.LEGALADDRESS,
                            city: fieldsValue.city,
                            country: fieldsValue.countri,
                            postalcode: formatPSC(fieldsValue.postalcode, fieldsValue.countri),
                            firstaddressline: fieldsValue.firstaddressline,
                            ...(hqCopy && {
                                additionaladdressline: formData?.spolecnost?.legalname
                            }),
                            ...(fieldsValue.region && {
                                region: fieldsValue.region
                            })
                        },
                        ...(fieldsValue.altlanguage
                            ? [
                                  {
                                      typadresy: hqCopy
                                          ? ETypAdresy.HQTRANSALTERNATIVE
                                          : ETypAdresy.LEGALADDRESSALTERNATIVE,
                                      city: fieldsValue.altlangcity,
                                      country: fieldsValue.countri,
                                      firstaddressline: fieldsValue.altlangfirstaddressline,
                                      lang: fieldsValue.altlangcode,
                                      ...(hqCopy && {
                                          additionaladdressline: formData?.spolecnost?.legalname
                                      }),
                                      postalcode: formatPSC(fieldsValue.altlangpostalcode, fieldsValue.countri),
                                      ...(fieldsValue.region && {
                                          region: fieldsValue.region
                                      })
                                  }
                              ]
                            : [])
                    ]
                }
            };
        },
        CHANGE_HQ_ADDRESS: (fieldsValue: any) => {
            return {
                spolecnost: {
                    adresy: [
                        {
                            typadresy: ETypAdresy.HEADQUARTERSADDRES,
                            additionaladdressline: fieldsValue.hqfirstaddressline,
                            city: fieldsValue.hqcity,
                            country: fieldsValue.hqcountry,
                            firstaddressline:
                                formData?.typzadosti === ETypZadostiLei.FUND
                                    ? 'c/o ' + fieldsValue.hqadditionaladdressline
                                    : fieldsValue.hqadditionaladdressline,
                            postalcode: formatPSC(fieldsValue.hqpostalcode, fieldsValue.hqcountry),
                            ...(fieldsValue.hqregion && {
                                region: fieldsValue.hqregion
                            })
                        },
                        ...(fieldsValue.hqaltlanguage
                            ? [
                                  {
                                      typadresy: ETypAdresy.HQTRANSALTERNATIVE,
                                      additionaladdressline: fieldsValue.althqlangfirstaddressline,
                                      city: fieldsValue.althqlangcity,
                                      country: fieldsValue.hqcountry,
                                      firstaddressline: fieldsValue.althqlangadditionaladdressline,
                                      postalcode: formatPSC(fieldsValue.althqlangpostalcode, fieldsValue.hqcountry),
                                      ...(fieldsValue.hqregion && {
                                          region: fieldsValue.hqregion
                                      }),
                                      lang: fieldsValue.althqlangcode
                                  }
                              ]
                            : [])
                    ]
                }
            };
        }
    };

    const validateChanges = (fieldsValue: any) => {
        // otherentityname0 zistuje ci ide o otherNameChange
        const newData = fieldsValue.otherentityname0
            ? {
                  otherentitynames: otherEntityNames
                  /*     ...(fieldsValue.transliteratedotherentitynames && {
                      transliteratedotherentitynames: fieldsValue.transliteratedotherentitynames
                  }),
                  ...(fieldsValue.transliteratedotherentitynames && {
                      transliteratedentitynametype: 'PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME'
                  })*/
              }
            : fieldsValue.entitycreationddate
              ? {
                    entitycreationddate: fieldsValue.entitycreationddate.format('YYYY-MM-DD')
                }
              : {
                    ...fieldsValue
                };
        delete newData.soubor;
        delete newData.eventstatus;
        delete newData.datumzmeny;
        Object.keys(newData).forEach(key => newData[key] === undefined && delete newData[key]);
        const getVals: any = {
            VZNIKSPOLECNOSTI: {
                entitycreationddate: formData?.spolecnost?.entitycreationddate
            },
            CHANGE_LEGAL_NAME: {
                legalname: formData?.spolecnost?.legalname
            },
            CHANGE_OTHER_NAMES: {
                otherentitynames: formData?.spolecnost?.otherentitynames || []
                /*  ...(formData?.spolecnost?.transliteratedotherentitynames && {
                    transliteratedotherentitynames: formData?.spolecnost?.transliteratedotherentitynames,
                    transliteratedentitynametype: 'PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME'
                }) */
            },
            CHANGE_LEGAL_FORM: {
                ...(formData?.spolecnost?.entitylegalformcode && {
                    entitylegalformcode: formData?.spolecnost?.entitylegalformcode
                }),
                ...(formData?.spolecnost?.otherlegalform && {
                    otherlegalform: formData?.spolecnost?.otherlegalform
                })
            },
            OSTATNI: {},
            CHANGE_LEGAL_ADDRESS: {
                ...(LEGALADDRESS?.length &&
                    LEGALADDRESS[0].firstaddressline && {
                        firstaddressline: LEGALADDRESS[0].firstaddressline
                    }),
                ...(LEGALADDRESS?.length &&
                    LEGALADDRESS[0].city && {
                        city: LEGALADDRESS[0].city
                    }),
                ...(LEGALADDRESS?.length &&
                    LEGALADDRESS[0].postalcode && {
                        postalcode: LEGALADDRESS[0].postalcode
                    }),
                ...(LEGALADDRESS?.length &&
                    LEGALADDRESS[0].country && {
                        country: LEGALADDRESS[0].country
                    }),
                ...(LEGALADDRESS?.length &&
                    LEGALADDRESS[0].region && {
                        region: LEGALADDRESS[0].region
                    }),
                altlanguage: LEGALADDRESSALTERNATIVE ? LEGALADDRESSALTERNATIVE.length > 0 : false,
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].lang && {
                        altlangcode: LEGALADDRESSALTERNATIVE[0].lang
                    }),
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].firstaddressline && {
                        altlangfirstaddressline: LEGALADDRESSALTERNATIVE[0].firstaddressline
                    }),
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].city && {
                        altlangcity: LEGALADDRESSALTERNATIVE[0].city
                    }),
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].postalcode && {
                        altlangpostalcode: LEGALADDRESSALTERNATIVE[0].postalcode
                    }),
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].country && {
                        countri: LEGALADDRESSALTERNATIVE[0].country
                    }),
                ...(LEGALADDRESSALTERNATIVE?.length &&
                    LEGALADDRESSALTERNATIVE[0].region && {
                        region: LEGALADDRESSALTERNATIVE[0].region
                    })
            },
            CHANGE_HQ_ADDRESS: {
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].additionaladdressline && {
                        hqadditionaladdressline: HQADDRESS[0].additionaladdressline
                    }),
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].firstaddressline && {
                        hqfirstaddressline: HQADDRESS[0].firstaddressline
                    }),
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].city && {
                        hqcity: HQADDRESS[0].city
                    }),
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].postalcode && {
                        hqpostalcode: HQADDRESS[0].postalcode
                    }),
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].country && {
                        hqcountry: HQADDRESS[0].country
                    }),
                ...(HQADDRESS?.length &&
                    HQADDRESS[0].region && {
                        hqregion: HQADDRESS[0].region
                    })
            },
            CHANGE_HQ_ADDRESS_ALT: {
                hqaltlanguage: HQTRANSALT ? HQTRANSALT.length > 0 : false,
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].lang && {
                        althqlangcode: HQTRANSALT[0].lang
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].additionaladdressline && {
                        althqlangadditionaladdressline: HQTRANSALT[0].additionaladdressline
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].firstaddressline && {
                        althqlangfirstaddressline: HQTRANSALT[0].firstaddressline
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].city && {
                        althqlangcity: HQTRANSALT[0].city
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].postalcode && {
                        althqlangpostalcode: HQTRANSALT[0].postalcode
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].country && {
                        hqcountry: HQTRANSALT[0].country
                    }),
                ...(HQTRANSALT?.length &&
                    HQTRANSALT[0].region && {
                        hqregion: HQTRANSALT[0].region
                    })
            }
        };
        const OldData =
            selectedEvent?.eventtype && selectedEvent?.eventtype === EEventType.CHANGE_HQ_ADDRESS
                ? {
                      ...getVals.CHANGE_HQ_ADDRESS,
                      ...getVals.CHANGE_HQ_ADDRESS_ALT
                  }
                : selectedEvent?.eventtype && getVals[selectedEvent.eventtype];
        return isEqual(newData, OldData);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (validateChanges(fieldsValue)) {
            setSameValsErr(true);
        } else {
            const popUpCheckArray = currentEvents?.filter(
                e => e.eventtype === 'CHANGE_LEGAL_FORM' || e.eventtype === 'CHANGE_LEGAL_NAME'
            );
            if (
                popUpCheckArray?.filter(e => e.eventtype === 'CHANGE_LEGAL_FORM').length &&
                popUpCheckArray?.length < 2 &&
                selectedEvent?.eventtype === EEventType.CHANGE_LEGAL_FORM
            ) {
                setOpenModal('name');
            }
            if (
                popUpCheckArray?.length === 2 &&
                formData?.spolecnost?.jurisdikce !== 'CZ' &&
                currentEvents?.filter(
                    e => e.eventtype === 'CHANGE_LEGAL_ADDRESS' || e.eventtype === 'CHANGE_HQ_ADDRESS'
                ).length &&
                formData?.typzadosti !== ETypZadostiLei.SOLE_PROPRIETOR &&
                currentEvents?.filter(e => e.eventtype === EEventType.OSTATNI).length < 1 &&
                (selectedEvent?.eventtype === EEventType.CHANGE_LEGAL_ADDRESS ||
                    selectedEvent?.eventtype === EEventType.CHANGE_HQ_ADDRESS)
            ) {
                setOpenModal('ico');
            }
            setFormData(pv => {
                return {
                    ...pv,
                    ...(typeof selectedEventIndex === 'number' && selectedEventIndex < (formData?.events?.length || -1)
                        ? {
                              events: [
                                  ...(formData?.events || []).map((e, i) => {
                                      return i === selectedEventIndex && selectedEvent
                                          ? {
                                                idzadosti: selectedEvent.idzadosti,
                                                ...((fieldsValue.eventstatus || selectedEvent.eventstatus) && {
                                                    eventstatus: fieldsValue.eventstatus || selectedEvent.eventstatus
                                                }),
                                                datumprogres: dayjs().format('YYYY-MM-DD'),
                                                ...(fieldsValue.datumzmeny && {
                                                    datumzmeny: fieldsValue.datumzmeny.format('YYYY-MM-DD')
                                                }),
                                                ...(fieldsValue.datumcompleted && {
                                                    datumcompleted: fieldsValue.datumcompleted.format('YYYY-MM-DD')
                                                }),
                                                eventtype: selectedEvent.eventtype,
                                                ...(selectedEvent.eventtype === EEventType.OSTATNI && {
                                                    ostatnievent: selectedEvent.ostatnievent
                                                }),
                                                validationdocuments: 'ACCOUNTS_FILING',
                                                soubory: prilozeneSoubory,
                                                hlasenyzmeny: _getKeyValue_(selectedEvent.eventtype || '')(
                                                    formDataSetters
                                                )(fieldsValue)
                                            }
                                          : e;
                                  })
                              ]
                          }
                        : {
                              events: [
                                  ...(formData?.events || []),
                                  ...(selectedEvent
                                      ? [
                                            {
                                                idzadosti: selectedEvent.idzadosti,
                                                ...((fieldsValue.eventstatus || selectedEvent.eventstatus) && {
                                                    eventstatus: fieldsValue.eventstatus || selectedEvent.eventstatus
                                                }),
                                                datumprogres: dayjs().format('YYYY-MM-DD'),
                                                ...(fieldsValue.datumzmeny && {
                                                    datumzmeny: fieldsValue.datumzmeny.format('YYYY-MM-DD')
                                                }),
                                                ...(fieldsValue.datumcompleted && {
                                                    datumcompleted: fieldsValue.datumcompleted.format('YYYY-MM-DD')
                                                }),
                                                eventtype: selectedEvent.eventtype,
                                                ...(selectedEvent.eventtype === EEventType.OSTATNI && {
                                                    ostatnievent: selectedEvent.ostatnievent
                                                }),
                                                validationdocuments: 'ACCOUNTS_FILING',
                                                soubory: prilozeneSoubory,
                                                hlasenyzmeny: _getKeyValue_(selectedEvent.eventtype || '')(
                                                    formDataSetters
                                                )(fieldsValue)
                                            }
                                        ]
                                      : [])
                              ]
                          })
                };
            });
            typeof !selectedEventIndex === 'number' && setCurrentStep(pv => pv + 1);
            typeof !selectedEventIndex === 'number' && setIsEdit(false);

            fieldsValue.hqsame
                ? (
                      formData?.events?.filter((e, i) => {
                          if (e.eventtype === EEventType.CHANGE_HQ_ADDRESS) {
                              setSelectedEventIndex(i);
                              return true;
                          }
                          return false;
                      }) || []
                  ).length < 1 && setSelectedEventIndex((formData?.events?.length || 0) + 1)
                : setSelectedEventIndex(undefined);

            fieldsValue.hqsame
                ? (setSelectedEvent(undefined),
                  setFileList([]),
                  setTimeout(
                      () =>
                          setSelectedEvent({
                              idzadosti: selectedEvent?.idzadosti,
                              ...((fieldsValue.eventstatus || selectedEvent?.eventstatus) && {
                                  eventstatus: fieldsValue.eventstatus || selectedEvent?.eventstatus
                              }),
                              datumprogres: dayjs().format('YYYY-MM-DD'),
                              ...(fieldsValue.datumzmeny && {
                                  datumzmeny: fieldsValue.datumzmeny.format('YYYY-MM-DD')
                              }),
                              ...(fieldsValue.datumcompleted && {
                                  datumcompleted: fieldsValue.datumcompleted.format('YYYY-MM-DD')
                              }),
                              eventtype: EEventType.CHANGE_HQ_ADDRESS,
                              validationdocuments: 'ACCOUNTS_FILING',
                              hlasenyzmeny: _getKeyValue_(EEventType.CHANGE_LEGAL_ADDRESS)(formDataSetters)(
                                  fieldsValue,
                                  true
                              )
                          }),
                      100
                  ))
                : (setSelectedEvent(undefined),
                  setSelectedEventIndex(undefined),
                  setRadioEventype(undefined),
                  setRadioSubEvenType(undefined),
                  setShowDefaultValues({
                      region: true,
                      hqregion: true
                  }));
            setTimeout(() => form.resetFields(), 100);
        }
    };

    const zmenaJsx = {
        VZNIKSPOLECNOSTI: (e: ILeiDetailEvent) => (
            <>
                <DatePickerComponent
                    label={
                        formData?.typzadosti === ETypZadostiLei.FUND
                            ? 'LEI_DETAIL_DATUM_SPOL_FUND'
                            : 'LEI_DETAIL_DATUM_SPOL'
                    }
                    infoTooltipText="LEI_DETAIL_DATUM_SPOL_TOOLTIP"
                    name="entitycreationddate"
                    initialValue={
                        e?.hlasenyzmeny?.spolecnost?.entitycreationddate
                            ? dayjs(e.hlasenyzmeny.spolecnost.entitycreationddate)
                            : undefined
                    }
                    disabled={isPrehled}
                    disabledDate={current => current > dayjs()}
                />
            </>
        ),
        CHANGE_LEGAL_NAME: (e: ILeiDetailEvent) => (
            <>
                <InputComponent
                    label={'LEI_DETAIL_PRAV_SPOL'}
                    name="legalname"
                    initialValue={e?.hlasenyzmeny?.spolecnost?.legalname || rejstrikVals?.legalname}
                    maxLength={100}
                    disabled={isPrehled}
                />
            </>
        ),
        ...(formData?.typzadosti !== ETypZadostiLei.BRANCH &&
        formData?.typzadosti !== ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
            ? {
                  CHANGE_OTHER_NAMES: () => (
                      <>
                          {otherEntityNames?.map((o, i) => {
                              form.setFieldsValue({
                                  [`otherentityname${i}`]: o.otherentityname
                              });
                              return (
                                  <div key={i}>
                                      {(isPrehled ? o.otherentityname : true) && (
                                          <InputComponent
                                              disabled={isPrehled}
                                              label="LEI_DETAIL_JINY"
                                              name={`otherentityname${i}`}
                                              initialValue={o.otherentityname}
                                              onChange={ev =>
                                                  setOtherEntityNames(pv => {
                                                      let prevState = pv ? [...pv] : [];
                                                      ev.target.value === ''
                                                          ? ((prevState = prevState.filter(u => u.otherentityname)),
                                                            form.setFieldsValue({
                                                                [`entitynametype${i}`]: undefined
                                                            }))
                                                          : null;
                                                      prevState[i] = {
                                                          ...(ev.target.value ? prevState[i] : []),
                                                          otherentityname: ev.target.value
                                                      };
                                                      return prevState;
                                                  })
                                              }
                                              maxLength={100}
                                              notRequired={true}
                                          />
                                      )}
                                      {o.otherentityname && (
                                          <SelectComponent
                                              disabled={isPrehled}
                                              name={`entitynametype${i}`}
                                              labelParagraph="LEI_DETAIL_NAZEV_TYP"
                                              isFormItem={true}
                                              data={leiTypNazvuSelect}
                                              onChange={val =>
                                                  setOtherEntityNames(pv => {
                                                      const prevState = pv ? [...pv] : [];
                                                      prevState[i] = {
                                                          ...prevState[i],
                                                          entitynametype: val
                                                      };
                                                      prevState.length ===
                                                          prevState.filter(u => u.otherentityname).length &&
                                                          form.getFieldValue(`lang${i}`) &&
                                                          prevState.push({});
                                                      return prevState;
                                                  })
                                              }
                                              defaultValue={o.entitynametype}
                                          />
                                      )}
                                      {o.otherentityname && (
                                          <SelectComponent
                                              name={`lang${i}`}
                                              labelParagraph="LEI_DETAIL_NAZEV_JAZYK"
                                              isFormItem={true}
                                              data={leiJazykySelect}
                                              onChange={val =>
                                                  setOtherEntityNames(pv => {
                                                      const prevState = pv ? [...pv] : [];
                                                      prevState[i] = {
                                                          ...prevState[i],
                                                          lang: val
                                                      };
                                                      prevState.length ===
                                                          prevState.filter(u => u.otherentityname).length &&
                                                          form.getFieldValue(`entitynametype${i}`) &&
                                                          prevState.push({});
                                                      return prevState;
                                                  })
                                              }
                                              defaultValue={o.lang}
                                              disabled={isPrehled}
                                          />
                                      )}
                                  </div>
                              );
                          })}
                      </>
                  )
              }
            : {}),
        CHANGE_LEGAL_FORM: (e: ILeiDetailEvent) => (
            <>
                <SelectComponent
                    disabled={isPrehled}
                    name="entitylegalformcode"
                    labelParagraph="LEI_DETAIL_PRAVFORMA"
                    isFormItem={true}
                    showOptionValue={true}
                    optionValueFilter={['8888']}
                    data={[
                        ...((Object.keys(leiElfKodySelect).includes(
                            (e?.hlasenyzmeny?.spolecnost?.adresy?.length
                                ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                : formData?.spolecnost?.adresy && formData.spolecnost.adresy[0].country) || ''
                        ) &&
                            _getKeyValue_(
                                (e?.hlasenyzmeny?.spolecnost?.adresy?.length
                                    ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                    : formData?.spolecnost?.adresy && formData.spolecnost.adresy[0].country) || ''
                            )(leiElfKodySelect)) ||
                            []),
                        ...leiElfKodyPermanent
                    ]}
                    onChange={() => rerender()}
                    defaultValue={e?.hlasenyzmeny?.spolecnost?.entitylegalformcode || rejstrikVals?.entitylegalformcode}
                />
                {form.getFieldValue('entitylegalformcode') === '8888' && (
                    <InputComponent
                        disabled={isPrehled}
                        label="LEI_DETAIL_PRAV_NENALEZENO"
                        name="otherlegalform"
                        initialValue={e?.hlasenyzmeny?.spolecnost?.otherlegalform}
                        maxLength={100}
                    />
                )}
            </>
        ),
        OSTATNI: (e: ILeiDetailEvent) => (
            <>
                {selectedEvent?.ostatnievent !== EJinyTyp.MERGERS_AND_ACQUISITIONS && (
                    <InputTextArea
                        rows={4}
                        name="popis"
                        initialValue={e?.hlasenyzmeny?.popis && e?.hlasenyzmeny?.popis}
                        label="LEI_DETAIL_NELZEUVEST_INPUT"
                        maxLength={500}
                    />
                )}
                {selectedEvent?.ostatnievent === EJinyTyp.MERGERS_AND_ACQUISITIONS && (
                    <LoadingWrapper loading={leiCheckLoading} loadingText="NACITANI_DAT">
                        <InputComponent
                            disabled={isPrehled}
                            label="LEI_SUCCESSOR_ENTITY"
                            name="successorentitylei"
                            initialValue={e?.hlasenyzmeny?.successorentitylei}
                            notRequired={true}
                            rules={[
                                ...leiValidation(async (value: string) => {
                                    setLeiCheckLoading(true);
                                    const resp = value ? await checkLeiApi(value).catch(() => null) : null;
                                    setLeiCheckLoading(false);
                                    resp?.spolecnost &&
                                        form.setFieldsValue({
                                            successorentityname: resp.spolecnost
                                        });
                                    rerender();
                                    if (
                                        resp?.stavlei === 'RETIRED' ||
                                        resp?.stavlei === 'ANNULLED' ||
                                        resp?.stavlei === 'DUPLICATE'
                                    ) {
                                        return setLeiCheckError('CHYBNE_LEI');
                                    }
                                    if (!resp && value) {
                                        return setLeiCheckError('LEI_CHECK_ERROR');
                                    }
                                    return setLeiCheckError('');
                                }),
                                () => ({
                                    validator(_, value: string) {
                                        if (!value && !form.getFieldValue('successorentityname')) {
                                            form.validateFields(['successorentityname']);
                                            return Promise.reject(
                                                <TranslateText>LEI_AKTUALIZACE_SUCCESSOR_ERR</TranslateText>
                                            );
                                        }
                                        if (!value || !leiCheckError) return Promise.resolve();
                                        return Promise.reject();
                                    }
                                })
                            ]}
                            maxLength={20}
                            onChange={() => {
                                form.setFieldsValue({
                                    successorentityname: undefined
                                });
                                setLeiCheckError('');
                            }}
                            validateTrigger={['onBlur', 'onSubmit']}
                            extramessage={leiCheckError}
                            validateStatus={leiCheckError ? 'error' : undefined}
                        />

                        <InputComponent
                            label="LEI_SUCCESSOR_ENTITY_NAME"
                            name="successorentityname"
                            disabled={!!form.getFieldValue('successorentitylei')}
                            initialValue={e?.hlasenyzmeny?.successorentityname}
                            maxLength={80}
                            notRequired={true}
                            rules={[
                                {
                                    required: false,
                                    message: ''
                                },
                                () => ({
                                    validator(_, value: string) {
                                        if (!value && !form.getFieldValue('successorentitylei'))
                                            return Promise.reject(
                                                <TranslateText>LEI_AKTUALIZACE_SUCCESSOR_ERR</TranslateText>
                                            );
                                        form.validateFields(['successorentitylei']);
                                        return Promise.resolve();
                                    }
                                })
                            ]}
                        />
                    </LoadingWrapper>
                )}
            </>
        ),
        CHANGE_LEGAL_ADDRESS: (e: ILeiDetailEvent) => {
            return (
                <>
                    <InputComponent
                        disabled={isPrehled}
                        label="ULICE_CP"
                        name="firstaddressline"
                        autoComplete="new-password"
                        initialValue={
                            (e?.hlasenyzmeny?.spolecnost?.adresy &&
                                e?.hlasenyzmeny?.spolecnost.adresy[0].firstaddressline) ||
                            (rejstrikVals?.adresy &&
                                rejstrikVals.adresy.filter(u => u.typadresy === ETypAdresy.LEGALADDRESS)[0]
                                    .firstaddressline)
                        }
                        maxLength={100}
                    />
                    <InputComponent
                        disabled={isPrehled}
                        label="MESTO"
                        name="city"
                        autoComplete="new-password"
                        initialValue={
                            (e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy[0].city) ||
                            (rejstrikVals?.adresy &&
                                rejstrikVals.adresy.filter(u => u.typadresy === ETypAdresy.LEGALADDRESS)[0].city)
                        }
                        maxLength={100}
                    />
                    <InputComponent
                        disabled={isPrehled}
                        label="PSC"
                        name="postalcode"
                        autoComplete="new-password"
                        initialValue={
                            (e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy[0].postalcode) ||
                            (rejstrikVals?.adresy &&
                                rejstrikVals.adresy.filter(u => u.typadresy === ETypAdresy.LEGALADDRESS)[0].postalcode)
                        }
                        rules={pscValidation('countri')}
                        maxLength={10}
                        usePscFormater={
                            form.getFieldValue('countri') === 'SK' || form.getFieldValue('countri') === 'CZ'
                        }
                    />
                    <SelectComponent
                        disabled={isPrehled}
                        name="countri"
                        autoComplete="new-password"
                        labelParagraph="STAT_SIDLA"
                        isFormItem={true}
                        data={cisStaty}
                        onChange={() => {
                            setShowDefaultValues(pv => {
                                return {
                                    ...pv,
                                    region: false
                                };
                            });
                            form.setFieldsValue({
                                region: undefined
                            });
                            form.validateFields(['postalcode']);
                        }}
                        defaultValue={
                            e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                : rejstrikVals?.adresy
                                  ? rejstrikVals.adresy.filter(u => u.typadresy === ETypAdresy.LEGALADDRESS)[0].country
                                  : undefined
                        }
                    />
                    {Object.keys(leiCountryRegionSelect).includes(
                        form.getFieldValue('countri') ||
                            (e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length
                                ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                : '')
                    ) && (
                        <SelectComponent
                            disabled={isPrehled}
                            name="region"
                            autoComplete="new-password"
                            labelParagraph="STAT_SIDLA_REGION"
                            isFormItem={true}
                            data={_getKeyValue_(form.getFieldValue('countri'))(leiCountryRegionSelect)}
                            onChange={() => rerender()}
                            defaultValue={
                                showDefaultValues.region
                                    ? e?.hlasenyzmeny?.spolecnost?.adresy &&
                                      e?.hlasenyzmeny?.spolecnost.adresy[0].region
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[0].region
                                        : undefined
                                    : undefined
                            }
                        />
                    )}
                    <Form.Item
                        style={{
                            marginBottom: 8,
                            fontWeight: 600
                        }}
                        name="altlanguage"
                        label={<TranslateText>LEI_DETAIL_ALT_JAZYK</TranslateText>}
                        initialValue={(e?.hlasenyzmeny?.spolecnost?.adresy || []).length > 1}
                        valuePropName="checked"
                    >
                        <Checkbox
                            disabled={isPrehled}
                            style={{
                                position: 'relative',
                                top: -10
                            }}
                            onChange={() => rerender()}
                        />
                    </Form.Item>
                    {form.getFieldValue('altlanguage') === true && (
                        <>
                            <Title level={5} dividerTitle={true} text={'LEI_DETAIL_ADRESA_TITLE_VARIANTA'} />
                            <SelectComponent
                                disabled={isPrehled}
                                name="altlangcode"
                                autoComplete="new-password"
                                labelParagraph="LEI_DETAIL_KOD_JAZYKA"
                                isFormItem={true}
                                data={leiJazykySelect}
                                onChange={() => rerender()}
                                defaultValue={
                                    e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].lang
                                        : undefined
                                }
                            />
                            <InputComponent
                                disabled={isPrehled}
                                label="ULICE_CP"
                                name="altlangfirstaddressline"
                                autoComplete="new-password"
                                initialValue={
                                    e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].firstaddressline
                                        : undefined
                                }
                                maxLength={100}
                            />
                            <InputComponent
                                disabled={isPrehled}
                                label="MESTO"
                                name="altlangcity"
                                autoComplete="new-password"
                                initialValue={
                                    e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].city
                                        : undefined
                                }
                                maxLength={100}
                            />
                            <InputComponent
                                disabled={isPrehled}
                                label="PSC"
                                name="altlangpostalcode"
                                autoComplete="new-password"
                                initialValue={
                                    e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].postalcode
                                        : undefined
                                }
                                rules={pscValidation('countri')}
                                maxLength={10}
                                usePscFormater={
                                    form.getFieldValue('countri') === 'SK' || form.getFieldValue('countri') === 'CZ'
                                }
                            />
                            <SelectComponent
                                disabled={true}
                                name="countri"
                                autoComplete="new-password"
                                labelParagraph="STAT_SIDLA"
                                isFormItem={true}
                                data={cisStaty}
                                onChange={() => {
                                    setShowDefaultValues(pv => {
                                        return {
                                            ...pv,
                                            altregion: false
                                        };
                                    });
                                    form.setFieldsValue({
                                        altregion: undefined
                                    });
                                    form.validateFields(['altlangpostalcode']);
                                }}
                                defaultValue={
                                    e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                        : undefined
                                }
                            />
                            {Object.keys(leiCountryRegionSelect).includes(
                                form.getFieldValue('countri') ||
                                    (e?.hlasenyzmeny?.spolecnost?.adresy &&
                                    e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                        : '')
                            ) && (
                                <SelectComponent
                                    disabled={true}
                                    name="region"
                                    autoComplete="new-password"
                                    labelParagraph="STAT_SIDLA_REGION"
                                    isFormItem={true}
                                    data={_getKeyValue_(
                                        form.getFieldValue('countri') ||
                                            (e?.hlasenyzmeny?.spolecnost?.adresy &&
                                            e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                                ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                                : undefined) ||
                                            (LEGALADDRESSALTERNATIVE?.length ? LEGALADDRESSALTERNATIVE[0].country : '')
                                    )(leiCountryRegionSelect)}
                                    onChange={() => rerender()}
                                    defaultValue={
                                        showDefaultValues.region
                                            ? e?.hlasenyzmeny?.spolecnost?.adresy &&
                                              e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                                ? e?.hlasenyzmeny?.spolecnost.adresy[1].region
                                                : undefined
                                            : undefined
                                    }
                                />
                            )}
                        </>
                    )}
                </>
            );
        },
        ...(formData?.typzadosti !== ETypZadostiLei.INTERNATIONAL_ORGANIZATION && {
            CHANGE_HQ_ADDRESS: (e: ILeiDetailEvent) => (
                <>
                    <InputComponent
                        disabled={isPrehled}
                        label="LEI_DETAIL_PRAV_SPOL"
                        addonBefore={formData?.typzadosti === ETypZadostiLei.FUND ? 'c/o' : undefined}
                        name="hqadditionaladdressline"
                        autoComplete="new-password"
                        //  disabled={entityCheck === 'OK'}
                        initialValue={
                            e?.hlasenyzmeny?.spolecnost?.adresy &&
                            e?.hlasenyzmeny?.spolecnost.adresy[0].firstaddressline?.replace('c/o ', '')
                        }
                        maxLength={100}
                    />
                    <InputComponent
                        disabled={isPrehled}
                        label="ULICE_CP"
                        name="hqfirstaddressline"
                        autoComplete="new-password"
                        initialValue={
                            e?.hlasenyzmeny?.spolecnost?.adresy &&
                            e?.hlasenyzmeny?.spolecnost.adresy[0].additionaladdressline
                        }
                        maxLength={100}
                    />
                    <InputComponent
                        disabled={isPrehled}
                        label="MESTO"
                        name="hqcity"
                        autoComplete="new-password"
                        initialValue={e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy[0].city}
                        maxLength={100}
                    />
                    <InputComponent
                        disabled={isPrehled}
                        label="PSC"
                        name="hqpostalcode"
                        autoComplete="new-password"
                        initialValue={
                            e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy[0].postalcode
                        }
                        maxLength={10}
                        rules={pscValidation('hqcountry')}
                        usePscFormater={
                            form.getFieldValue('hqcountry') === 'SK' || form.getFieldValue('hqcountry') === 'CZ'
                        }
                    />
                    <SelectComponent
                        disabled={isPrehled}
                        name="hqcountry"
                        autoComplete="new-password"
                        labelParagraph="STAT_SIDLA"
                        isFormItem={true}
                        data={cisStaty}
                        onChange={() => {
                            setShowDefaultValues(pv => {
                                return {
                                    ...pv,
                                    hqregion: false
                                };
                            });
                            form.setFieldsValue({
                                hqregion: undefined
                            });
                            form.validateFields(['hqpostalcode']);
                        }}
                        defaultValue={
                            e?.hlasenyzmeny?.spolecnost?.adresy
                                ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                : undefined
                        }
                    />
                    {Object.keys(leiCountryRegionSelect).includes(
                        form.getFieldValue('hqcountry') ||
                            (e?.hlasenyzmeny?.spolecnost?.adresy && e?.hlasenyzmeny?.spolecnost.adresy.length
                                ? e?.hlasenyzmeny?.spolecnost.adresy[0].country
                                : '')
                    ) && (
                        <SelectComponent
                            disabled={isPrehled}
                            name="hqregion"
                            autoComplete="new-password"
                            labelParagraph="STAT_SIDLA_REGION"
                            isFormItem={true}
                            data={_getKeyValue_(form.getFieldValue('hqcountry'))(leiCountryRegionSelect)}
                            onChange={() => rerender()}
                            defaultValue={
                                showDefaultValues.hqregion
                                    ? e?.hlasenyzmeny?.spolecnost?.adresy
                                        ? e?.hlasenyzmeny?.spolecnost.adresy[0].region
                                        : undefined
                                    : undefined
                            }
                        />
                    )}
                    <Form.Item
                        style={{
                            marginBottom: 8,
                            marginLeft: 10,
                            fontWeight: 600
                        }}
                        name="hqaltlanguage"
                        label={<TranslateText>LEI_DETAIL_ALT_JAZYK</TranslateText>}
                        initialValue={(e?.hlasenyzmeny?.spolecnost?.adresy || []).length > 1}
                        valuePropName="checked"
                    >
                        <Checkbox
                            disabled={isPrehled}
                            style={{
                                position: 'relative',
                                top: -10
                            }}
                            onChange={() => rerender()}
                        />
                    </Form.Item>
                    {
                        /* form.getFieldValue('shodnaadresa') !== true &&*/ form.getFieldValue('hqaltlanguage') ===
                            true && (
                            <>
                                <Title
                                    level={5}
                                    dividerTitle={true}
                                    text={
                                        formData?.typzadosti === ETypZadostiLei.FUND
                                            ? 'LEI_DETAIL_ADRESA_HQ_FUND_VARIANTA'
                                            : 'LEI_DETAIL_ADRESA_HQ_VARIANTA'
                                    }
                                />
                                <SelectComponent
                                    disabled={isPrehled}
                                    name="althqlangcode"
                                    autoComplete="new-password"
                                    labelParagraph="LEI_DETAIL_KOD_JAZYKA"
                                    isFormItem={true}
                                    data={leiJazykySelect}
                                    onChange={() => rerender()}
                                    defaultValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].lang
                                            : undefined
                                    }
                                />
                                <InputComponent
                                    disabled={isPrehled}
                                    label="LEI_DETAIL_PRAV_SPOL"
                                    name="althqlangadditionaladdressline"
                                    autoComplete="new-password"
                                    //  disabled={entityCheck === 'OK'}
                                    initialValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].additionaladdressline
                                            : undefined
                                    }
                                    maxLength={100}
                                />
                                <InputComponent
                                    disabled={isPrehled}
                                    label="ULICE_CP"
                                    name="althqlangfirstaddressline"
                                    autoComplete="new-password"
                                    initialValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].firstaddressline
                                            : undefined
                                    }
                                    maxLength={100}
                                />
                                <InputComponent
                                    disabled={isPrehled}
                                    label="MESTO"
                                    name="althqlangcity"
                                    autoComplete="new-password"
                                    initialValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].city
                                            : undefined
                                    }
                                    maxLength={100}
                                />
                                <InputComponent
                                    disabled={isPrehled}
                                    label="PSC"
                                    name="althqlangpostalcode"
                                    autoComplete="new-password"
                                    initialValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].postalcode
                                            : undefined
                                    }
                                    rules={pscValidation('hqcountry')}
                                    maxLength={10}
                                    usePscFormater={
                                        form.getFieldValue('hqcountry') === 'SK' ||
                                        form.getFieldValue('hqcountry') === 'CZ'
                                    }
                                />
                                <SelectComponent
                                    disabled={true}
                                    name="hqcountry"
                                    autoComplete="new-password"
                                    labelParagraph="STAT_SIDLA"
                                    isFormItem={true}
                                    data={cisStaty}
                                    onChange={() => {
                                        setShowDefaultValues(pv => {
                                            return {
                                                ...pv,
                                                hqregion: false
                                            };
                                        });
                                        form.setFieldsValue({
                                            hqregion: undefined
                                        });
                                        form.validateFields(['althqlangpostalcode']);
                                    }}
                                    defaultValue={
                                        e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                            : undefined
                                    }
                                />
                                {Object.keys(leiCountryRegionSelect).includes(
                                    form.getFieldValue('hqcountry') ||
                                        (e?.hlasenyzmeny?.spolecnost?.adresy &&
                                        e?.hlasenyzmeny?.spolecnost.adresy.length > 1
                                            ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                            : '')
                                ) && (
                                    <SelectComponent
                                        disabled={true}
                                        name="hqregion"
                                        autoComplete="new-password"
                                        labelParagraph="STAT_SIDLA_REGION"
                                        isFormItem={true}
                                        data={_getKeyValue_(
                                            form.getFieldValue('hqcountry') ||
                                                (e?.hlasenyzmeny?.spolecnost?.adresy &&
                                                e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                                    ? e?.hlasenyzmeny?.spolecnost.adresy[1].country
                                                    : undefined)
                                        )(leiCountryRegionSelect)}
                                        onChange={() => rerender()}
                                        defaultValue={
                                            showDefaultValues.hqregion
                                                ? e?.hlasenyzmeny?.spolecnost?.adresy &&
                                                  e?.hlasenyzmeny?.spolecnost?.adresy.length > 1
                                                    ? e?.hlasenyzmeny?.spolecnost.adresy[1].region
                                                    : undefined
                                                : undefined
                                        }
                                    />
                                )}
                            </>
                        )
                    }
                </>
            )
        })
    };

    const columns = [
        {
            title: <TranslateText>TYP</TranslateText>,
            key: 'eventtype',
            dataIndex: 'eventtype',
            render: (eventtype: string) => <TranslateText>{`LEI_AKTUALIZACE_${eventtype}`}</TranslateText>
        },
        {
            title: <TranslateText>LEI_DATUM_ZMENY</TranslateText>,
            key: 'datumzmeny',
            dataIndex: 'datumzmeny',
            render: (datumzmeny: string | null | undefined) => {
                return dayjs(datumzmeny).format('DD.MM.YYYY');
            }
            /*  sorter: (a: { datumzmeny: dayjs.DayjsInput }, b: { datumzmeny: dayjs.DayjsInput }) =>
                dayjs(a.datumzmeny).unix() - dayjs(b.datumzmeny).unix() */
        },
        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_STAV</TranslateText>,
            key: 'eventstatus',
            dataIndex: 'eventstatus',
            render: (eventstatus: string) => (eventstatus ? <TranslateText>{`${eventstatus}`}</TranslateText> : '')
            // sorter: (a: { stav: string }, b: { stav: string }) => (a.stav && b.stav ? a.stav.localeCompare(b.stav) : 0)
        },
        !PrehledOnly
            ? {
                  dataIndex: 'edit',
                  key: 'edit',
                  width: 200,
                  render: (_: ILeiDetailEvent, row: ILeiDetailEvent, index: number) => (
                      <div
                          style={{
                              display: 'flex',
                              justifyContent: 'space-evenly',
                              flexGrow: 1
                          }}
                      >
                          <AnchorComponent
                              id={`UpravaLeiUpravit${index}`}
                              onClick={() => {
                                  setSelectedEvent(row);
                                  setTimeout(
                                      () =>
                                          form.setFieldsValue({
                                              ...row,
                                              ...row.hlasenyzmeny,
                                              ...(row.datumzmeny && {
                                                  datumzmeny: dayjs(row.datumzmeny)
                                              }),
                                              ...(row.datumprogres && {
                                                  datumprogres: dayjs(row.datumprogres)
                                              }),
                                              ...(row.datumcompleted && {
                                                  datumcompleted: dayjs(row.datumcompleted)
                                              })
                                          }),
                                      100
                                  );
                                  setSelectedEventIndex(index);
                                  row.hlasenyzmeny?.successorentitylei &&
                                      setTimeout(() => form.validateFields(['successorentitylei']), 0);
                                  row.ostatnievent && setRadioSubEvenType(row.ostatnievent);
                              }}
                          >
                              <TranslateText>{isPrehled ? 'ZOBRAZIT' : 'BUTTON_UPRAVIT'}</TranslateText>
                          </AnchorComponent>
                          {!isPrehled && (
                              <AnchorComponent
                                  id={`UpravaLeiOdstranit${index}`}
                                  onClick={() => {
                                      setFormData(pv => {
                                          return {
                                              ...pv,
                                              events: pv?.events ? [...pv.events.filter((_e, i) => i !== index)] : []
                                          };
                                      });
                                      setCurrentEvents(pv => pv?.filter(e => e.eventtype !== row.eventtype));
                                  }}
                              >
                                  <TranslateText>ODSTRANIT</TranslateText>
                              </AnchorComponent>
                          )}
                      </div>
                  )
              }
            : {}
    ];

    return (
        <>
            {!isPrehled && (
                <Row className="button-row">
                    <ButtonComponent
                        buttontext="LEI_ZMENIT_EVENT_BUTTON"
                        type="primary"
                        disabled={
                            leiDataFiltered.filter((e: { value: EEventType }) => e.value !== EEventType.OSTATNI)
                                .length < 1
                        }
                        onClick={() => {
                            setSelectedEvent({
                                idzadosti: lei?.idVarsymZadosti?.id || 0,
                                soubory: [],
                                datumzmeny: ''
                            });
                            setSelectedEventIndex(formData?.events?.length || 0);
                        }}
                        id="upravaLeiZmenitEventBtn"
                    />
                    {formData?.typzadosti !== ETypZadostiLei.SOLE_PROPRIETOR && (
                        <ButtonComponent
                            id="upravaLeiZmenitOstatniBtn"
                            type="primary"
                            htmlType="button"
                            buttontext={'LEI_ZMENIT_EVENT_OSTATNI_BUTTON'}
                            disabled={!!formData?.events?.filter(e => e.eventtype === EEventType.OSTATNI).length}
                            onClick={() => {
                                setSelectedEvent({
                                    eventtype: EEventType.OSTATNI,
                                    idzadosti: lei?.idVarsymZadosti?.id || 0,
                                    soubory: [],
                                    datumzmeny: ''
                                });
                                setSelectedEventIndex(formData?.events?.length || 0);
                            }}
                        />
                    )}
                </Row>
            )}

            <Title
                text="PREHLED_ZMEN_UDALOSTI"
                level={5}
                dividerTitle={true}
                style={{
                    marginTop: 10
                }}
            />
            <TableComponent
                style={{
                    marginTop: 10
                }}
                columns={columns}
                rowKey={(_, i) => i || 0}
                rowClassName={(_, i) => (failedSouborValidations.includes(i) ? 'tableRowRed' : '')}
                dataSource={formData?.events}
                pagination={{
                    total: formData?.events?.length
                    //   onChange: page => setOffset((page - 1) * 10),
                    //  current: offset / 10 + 1,
                }}
                locale={{
                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                }}
            />
            {failedSouborValidations.length ? (
                <div
                    className="extramessage-text"
                    style={{
                        display: 'inline'
                    }}
                >
                    <TranslateText>LEI_PROFONDY_ERROR</TranslateText>
                </div>
            ) : null}
            {!isPrehled && (
                <Row className="button-row">
                    <ButtonComponent
                        onClick={() => prevStep && prevStep()}
                        buttontext="ZPET"
                        type="default"
                        id="upravaLeiZpetBtnAlt"
                    />
                    <ButtonComponent
                        loading={uploading}
                        id="upravaLeiPokracovatBtn"
                        type="primary"
                        htmlType="button"
                        buttontext={'POKRACOVAT'}
                        disabled={
                            !!failedSouborValidations.length ||
                            (!formData?.spolecnost?.entitycreationddate &&
                                !formData?.events?.filter(e => e.eventtype === EEventType.VZNIKSPOLECNOSTI).length)
                            //  rejstrikErrs?.entitylegalformcode ||
                            //  rejstrikErrs?.legaladdress ||
                            // rejstrikErrs?.legalname
                        }
                        onClick={() => {
                            const zruseniEvent = formData?.events?.filter(e => e.ostatnievent === EJinyTyp.DISSOLUTION);
                            if (zruseniEvent?.length && dayjs(zruseniEvent[0]?.datumzmeny) < dayjs()) {
                                setCurrentStep(
                                    formData?.typzadosti === 'FUND' || lei?.detailData?.typzadosti === 'FUND' ? 4 : 3
                                );
                            } else {
                                nextStep?.();
                            }
                        }}
                        extramessage={
                            !formData?.spolecnost?.entitycreationddate &&
                            !formData?.events?.filter(e => e.eventtype === EEventType.VZNIKSPOLECNOSTI).length
                                ? 'LEI_VZNIKSPOLECNOSTI_ERR'
                                : /*      : rejstrikErrs?.entitylegalformcode
                                ? 'LEI_NESHODNE_LEGAL_FORM'
                                : rejstrikErrs?.legaladdress
                                ? 'LEI_NESHODNE_LEGAL_ADDRESS'
                                : rejstrikErrs?.legalname
                                ? 'LEI_NESHODNE_LEGAL_NAME' */
                                  ''
                        }
                    />
                </Row>
            )}

            <Modal
                open={!!selectedEvent}
                destroyOnClose={true}
                onCancel={() => {
                    setSelectedEvent(undefined);
                    setSelectedEventIndex(undefined);
                    setTimeout(() => form.resetFields(), 100);
                    setSameValsErr(false);
                    setRadioEventype(undefined);
                    setRadioSubEvenType(undefined);
                    setShowDefaultValues({
                        region: true,
                        hqregion: true
                    });
                }}
                footer={
                    <>
                        {sameValsErr && (
                            <Row
                                style={{
                                    paddingBottom: 6
                                }}
                            >
                                <Paragraph text="LEI_UPDATE_DATA_ERR" className="extramessage-text" />
                            </Row>
                        )}
                        <Row className="button-row-modal">
                            <ButtonComponent
                                onClick={() => {
                                    setSelectedEvent(undefined);
                                    setSelectedEventIndex(undefined);
                                    setTimeout(() => form.resetFields(), 100);
                                    setSameValsErr(false);
                                    setRadioEventype(undefined);
                                    setRadioSubEvenType(undefined);
                                    setShowDefaultValues({
                                        region: true,
                                        hqregion: true
                                    });
                                }}
                                buttontext="ZAVRIT"
                                type="default"
                                id="leiUpravaZpetBtn"
                            />
                            {!isPrehled && (
                                <ButtonComponent
                                    type="primary"
                                    id="upravaLeiSubmitBtn"
                                    buttontext={'POKRACOVAT'}
                                    loading={uploading}
                                    onClick={
                                        !selectedEvent?.eventtype ||
                                        (selectedEvent.eventtype === EEventType.OSTATNI && !selectedEvent.ostatnievent)
                                            ? () => {
                                                  setSelectedEvent({
                                                      eventtype: radioSubEventType
                                                          ? EEventType.OSTATNI
                                                          : radioEventType,
                                                      ...(radioSubEventType && {
                                                          ostatnievent: radioSubEventType
                                                      }),
                                                      idzadosti: lei?.idVarsymZadosti?.id || 0,
                                                      soubory: [],
                                                      datumzmeny: '',
                                                      ...(radioEventType === EEventType.VZNIKSPOLECNOSTI && {
                                                          eventstatus: EEventStatus.COMPLETED
                                                      })
                                                  });
                                                  setCurrentEvents(pv =>
                                                      pv
                                                          ? [
                                                                ...pv,
                                                                {
                                                                    idzadosti: lei?.idVarsymZadosti?.id || 0,
                                                                    eventtype: radioSubEventType
                                                                        ? EEventType.OSTATNI
                                                                        : radioEventType,
                                                                    ...(radioSubEventType && {
                                                                        ostatnievent: radioSubEventType
                                                                    }),
                                                                    soubory: [],
                                                                    datumzmeny: '',
                                                                    ...(radioEventType ===
                                                                        EEventType.VZNIKSPOLECNOSTI && {
                                                                        eventstatus: EEventStatus.COMPLETED
                                                                    })
                                                                }
                                                            ]
                                                          : [
                                                                {
                                                                    idzadosti: lei?.idVarsymZadosti?.id || 0,
                                                                    eventtype: radioSubEventType
                                                                        ? EEventType.OSTATNI
                                                                        : radioEventType,
                                                                    ...(radioSubEventType && {
                                                                        ostatnievent: radioSubEventType
                                                                    }),
                                                                    soubory: [],
                                                                    datumzmeny: '',
                                                                    ...(radioEventType ===
                                                                        EEventType.VZNIKSPOLECNOSTI && {
                                                                        eventstatus: EEventStatus.COMPLETED
                                                                    })
                                                                }
                                                            ]
                                                  );
                                              }
                                            : () => form.validateFields().then(() => onFinish(form.getFieldsValue()))
                                    }
                                    disabled={
                                        (!radioEventType && !selectedEvent?.eventtype) ||
                                        (selectedEvent?.eventtype === EEventType.OSTATNI && !radioSubEventType)
                                    }
                                />
                            )}
                        </Row>
                    </>
                }
            >
                <>
                    {isPrehled ? (
                        <FormWrapper onFinish={() => {}} outForm={form}>
                            {selectedEvent && (
                                <>
                                    <Title
                                        text={`LEI_${selectedEvent.eventtype}`}
                                        level={4}
                                        style={{
                                            fontSize: 21,
                                            paddingTop: 10
                                        }}
                                    />
                                    {_getKeyValue_(selectedEvent.eventtype || '')(zmenaJsx)(selectedEvent)}
                                    {selectedEvent.datumzmeny && (
                                        <InputComponent
                                            notRequired={true}
                                            labelCol={{
                                                span: 6
                                            }}
                                            labelAlign="left"
                                            disabled={true}
                                            label="LEI_DATUM_ZMENY"
                                            name="datumzmeny2"
                                            initialValue={`${
                                                selectedEvent.datumzmeny
                                                    ? dayjs(selectedEvent.datumzmeny).format('DD.MM.YYYY')
                                                    : ''
                                            }`}
                                        />
                                    )}
                                    {selectedEvent.datumcompleted && (
                                        <InputComponent
                                            notRequired={true}
                                            disabled={true}
                                            label="LEI_DATUM_OZNAMENI"
                                            labelCol={{
                                                span: 6
                                            }}
                                            labelAlign="left"
                                            name="datumprogres"
                                            initialValue={`${
                                                selectedEvent.datumprogres
                                                    ? dayjs(selectedEvent.datumprogres).format('DD.MM.YYYY')
                                                    : ''
                                            }`}
                                        />
                                    )}
                                    {selectedEvent.datumcompleted && (
                                        <InputComponent
                                            notRequired={true}
                                            disabled={true}
                                            label="LEI_DATUM_POTVRDENI"
                                            labelCol={{
                                                span: 6
                                            }}
                                            labelAlign="left"
                                            name="datumcompleted"
                                            initialValue={`${
                                                selectedEvent.datumcompleted
                                                    ? dayjs(selectedEvent.datumcompleted).format('DD.MM.YYYY')
                                                    : ''
                                            }`}
                                        />
                                    )}
                                    {fileList && (
                                        <UploadComponent
                                            id="upravaDetailUploadPrehledBtn"
                                            {...{
                                                showRemoveIcon: false,
                                                onDownload: (file: UploadFile) =>
                                                    prepareFile(
                                                        file.fileName ? file.fileName : '',
                                                        lei?.idVarsymZadosti?.varsym || ''
                                                    ).then(resp => {
                                                        fileDownload(resp.redirect, file.name ? file.name : 'file');
                                                    }),
                                                hideButton: true
                                            }}
                                            fileList={fileList}
                                            accept={'.pdf, .rtf, .docx, .doc'}
                                        />
                                    )}
                                </>
                            )}
                        </FormWrapper>
                    ) : (
                        <>
                            <Row>
                                {selectedEvent?.eventtype &&
                                    (selectedEvent.eventtype !== EEventType.OSTATNI ||
                                        (selectedEvent?.eventtype === EEventType.OSTATNI &&
                                            selectedEvent.ostatnievent)) && (
                                        <h4
                                            style={{
                                                fontSize: 21,
                                                paddingTop: 10
                                            }}
                                        >
                                            <TranslateText>{`LEI_${selectedEvent.eventtype}`}</TranslateText>
                                            {selectedEvent.ostatnievent ? (
                                                <>
                                                    : <TranslateText>{selectedEvent.ostatnievent}</TranslateText>
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </h4>
                                    )}
                            </Row>
                            <FormWrapper
                                outForm={form}
                                onFinish={onFinish}
                                name="notlogin"
                                onValuesChange={() => setSameValsErr(false)}
                                onFinishFailed={err => console.log(err)}
                            >
                                {selectedEvent?.eventtype === EEventType.OSTATNI ? (
                                    <>{prehledFields.OSTATNI}</>
                                ) : selectedEvent?.eventtype === EEventType.VZNIKSPOLECNOSTI ? (
                                    <>{formData?.spolecnost?.entitycreationddate && prehledFields.VZNIKSPOLECNOSTI}</>
                                ) : selectedEvent?.eventtype === EEventType.CHANGE_HQ_ADDRESS ? (
                                    <>
                                        {prehledFields.HQ_ADDRESS}
                                        {prehledFields.HQ_ADDRESS_ALT}
                                    </>
                                ) : selectedEvent?.eventtype === EEventType.CHANGE_LEGAL_ADDRESS ? (
                                    <>
                                        {prehledFields.LEGAL_ADDRESS}
                                        {prehledFields.LEGAL_ADDRESS_ALT}
                                    </>
                                ) : selectedEvent?.eventtype === EEventType.CHANGE_LEGAL_FORM ? (
                                    <>{prehledFields.LEGAL_FORM}</>
                                ) : selectedEvent?.eventtype === EEventType.CHANGE_LEGAL_NAME ? (
                                    <>{prehledFields.LEGAL_NAME}</>
                                ) : selectedEvent?.eventtype === EEventType.CHANGE_OTHER_NAMES ? (
                                    <>{prehledFields.OTHER_NAMES}</>
                                ) : null}

                                {!selectedEvent?.eventtype ||
                                (selectedEvent.eventtype === EEventType.OSTATNI && !selectedEvent?.ostatnievent) ? (
                                    <div
                                        style={{
                                            position: 'relative'
                                        }}
                                    >
                                        <Title
                                            level={5}
                                            dividerTitle={true}
                                            text={
                                                selectedEvent?.eventtype === EEventType.OSTATNI
                                                    ? 'CHCI_ZMENIT_OSTATNI'
                                                    : 'CHCI_ZMENIT'
                                            }
                                        />
                                        {selectedEvent?.eventtype !== EEventType.OSTATNI ? (
                                            <Radio.Group
                                                onChange={ev => setRadioEventype(ev.target.value)}
                                                value={radioEventType}
                                            >
                                                <Space direction="vertical">
                                                    {leiDataFiltered.map(
                                                        (e: { value: any; labelcz: string }, index: number) => (
                                                            <Radio value={e.value} key={`${index}${e.value}`}>
                                                                <TranslateText>{e.labelcz}</TranslateText>
                                                            </Radio>
                                                        )
                                                    )}
                                                </Space>
                                            </Radio.Group>
                                        ) : (
                                            <Radio.Group
                                                onChange={ev => setRadioSubEvenType(ev.target.value)}
                                                value={radioSubEventType}
                                            >
                                                <Space direction="vertical">
                                                    {(formData?.typzadosti === ETypZadostiLei.GENERAL
                                                        ? leiJinyGeneral
                                                        : formData?.typzadosti ===
                                                            ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                                          ? leiJinyGovermentEntity
                                                          : formData?.typzadosti === ETypZadostiLei.BRANCH
                                                            ? leiJinyBranch
                                                            : formData?.typzadosti === ETypZadostiLei.FUND
                                                              ? leiJinyFund
                                                              : []
                                                    ).map(
                                                        (
                                                            e: { value?: any; labelcz?: string; labelen?: string },
                                                            index: number
                                                        ) => (
                                                            <Radio value={e.value} key={`${index}${e.value}`}>
                                                                <TranslateText>{e.labelcz || ''}</TranslateText>
                                                            </Radio>
                                                        )
                                                    )}
                                                </Space>
                                            </Radio.Group>
                                        )}
                                    </div>
                                ) : null}

                                {selectedEvent &&
                                    typeof selectedEventIndex === 'number' &&
                                    selectedEventIndex > -1 &&
                                    selectedEvent.eventtype &&
                                    (selectedEvent.eventtype !== EEventType.OSTATNI ||
                                        (selectedEvent.eventtype && selectedEvent.ostatnievent)) && (
                                        <>
                                            {_getKeyValue_(selectedEvent.eventtype)(zmenaJsx)(selectedEvent)}
                                            {selectedEvent.eventtype !== EEventType.VZNIKSPOLECNOSTI && (
                                                <>
                                                    {' '}
                                                    <Title
                                                        level={5}
                                                        dividerTitle={true}
                                                        text="LEI_ZMENA_PODKLADY"
                                                        style={{
                                                            fontSize: 17,
                                                            paddingTop: 10
                                                        }}
                                                    />{' '}
                                                    <DatePickerComponent
                                                        label="LEI_DATUM_ZMENY"
                                                        name="datumzmeny"
                                                        initialValue={
                                                            selectedEvent.datumzmeny
                                                                ? dayjs(selectedEvent.datumzmeny)
                                                                : undefined
                                                        }
                                                        onChange={(date: any) => {
                                                            rerender();
                                                            form.setFieldsValue({
                                                                eventstatus:
                                                                    date < dayjs()
                                                                        ? EEventStatus.COMPLETED
                                                                        : EEventStatus.IN_PROGRESS
                                                            });
                                                        }}
                                                    />
                                                    <>
                                                        <SelectComponent
                                                            name="eventstatus"
                                                            disabled={true}
                                                            defaultValue={
                                                                dayjs(
                                                                    selectedEvent.datumzmeny ||
                                                                        form.getFieldValue('datumzmeny')
                                                                ) < dayjs()
                                                                    ? EEventStatus.COMPLETED
                                                                    : EEventStatus.IN_PROGRESS
                                                            }
                                                            labelParagraph="STAV"
                                                            isFormItem={true}
                                                            data={leiZmenaStav}
                                                        />
                                                    </>
                                                    <Form.Item
                                                        name="soubor"
                                                        label={<Paragraph text={'SOUBOR'} strong={true} />}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                validator() {
                                                                    try {
                                                                        if (!fileList || fileList.length < 1)
                                                                            return Promise.reject(
                                                                                <TranslateText>
                                                                                    NEVALIDNI_POVINNA_POLOZKA_UPLOAD
                                                                                </TranslateText>
                                                                            );
                                                                        return Promise.resolve();
                                                                    } catch {
                                                                        return Promise.reject();
                                                                    }
                                                                }
                                                            }
                                                        ]}
                                                        validateTrigger="submit"
                                                    >
                                                        <div
                                                            style={{
                                                                marginBottom: 22
                                                            }}
                                                        >
                                                            {fileList && (
                                                                <UploadComponent
                                                                    id="upravaDetailUploadBtn"
                                                                    {...{
                                                                        extramessage: disableDownload
                                                                            ? 'LEI_UPLOAD_FILLIN'
                                                                            : '',
                                                                        onButtonClick: () => {
                                                                            form.validateFields(
                                                                                Object.keys(
                                                                                    form.getFieldsValue()
                                                                                ).filter(
                                                                                    (o: any) =>
                                                                                        !String(o).includes('soubor')
                                                                                )
                                                                            )
                                                                                .then(() => {
                                                                                    console.log('aaaa');
                                                                                    setDisableDownload(false);
                                                                                })
                                                                                .catch(err => {
                                                                                    console.log(err);
                                                                                    (err.errorfields || []).length
                                                                                        ? setDisableDownload(true)
                                                                                        : setDisableDownload(false);
                                                                                });
                                                                        },
                                                                        beforeUpload: (file: UploadFile) => {
                                                                            // kontrola maximalnej velkosti s suboru
                                                                            if ((file.size || 0) / 1024 / 1024 > 20) {
                                                                                NotificationComponent({
                                                                                    title: 'UPLOAD_MAX_SIZE',
                                                                                    description: 'UPLOAD_MAX_SIZE_TEXT',
                                                                                    type: ENotificationType.ERROR
                                                                                });
                                                                                return false;
                                                                            }
                                                                            if (disableDownload) return false;
                                                                            return true;
                                                                        },
                                                                        showDownloadIcon: true,
                                                                        onChange: (data: UploadChangeParam) => {
                                                                            if (
                                                                                data.file.status === 'uploading' &&
                                                                                setUploading
                                                                            )
                                                                                setUploading(true);
                                                                            if (
                                                                                data.file.status !== 'uploading' &&
                                                                                setUploading
                                                                            )
                                                                                setUploading(false);
                                                                            if (data.fileList.length) {
                                                                                if (data.file.response) {
                                                                                    form.validateFields(['soubor']);
                                                                                    let state = prilozeneSoubory
                                                                                        ? [...prilozeneSoubory]
                                                                                        : [];
                                                                                    state = data.fileList
                                                                                        .filter(
                                                                                            f =>
                                                                                                f.status &&
                                                                                                f.status !== 'error'
                                                                                        )
                                                                                        .map(u => {
                                                                                            return {
                                                                                                orignazev: u.name,
                                                                                                tempnazev: u.response
                                                                                                    ? u.response
                                                                                                          .tempnazev
                                                                                                    : u.fileName
                                                                                            };
                                                                                        });
                                                                                    // onFinish(form.getFieldsValue(), state);

                                                                                    setPrilozeneSoubory(state);
                                                                                }
                                                                                setFileList(pv => {
                                                                                    let state = pv ? [...pv] : [];
                                                                                    state = data.fileList
                                                                                        .filter(
                                                                                            f =>
                                                                                                f.status &&
                                                                                                f.status !== 'error'
                                                                                        )
                                                                                        .map(u => {
                                                                                            return {
                                                                                                uid: u.uid,
                                                                                                name: u.name,
                                                                                                fileName: u.fileName
                                                                                                    ? u.fileName
                                                                                                    : u.response
                                                                                                      ? u.response
                                                                                                            .tempnazev
                                                                                                      : '',
                                                                                                type: u.type!,
                                                                                                size: u.size!,
                                                                                                status: u.status
                                                                                                    ? u.status
                                                                                                    : 'error'
                                                                                            };
                                                                                        });
                                                                                    return state;
                                                                                });
                                                                            }
                                                                        },
                                                                        onRemove: (file: UploadFile) => {
                                                                            if (fileList?.length) {
                                                                                const oldState = [...fileList];
                                                                                const newState = oldState.filter(
                                                                                    u => u.uid !== file.uid
                                                                                );
                                                                                setFileList(pv => {
                                                                                    let state = pv ? [...pv] : [];
                                                                                    state = newState;
                                                                                    return state;
                                                                                });
                                                                                const newSoubory = [
                                                                                    ...(prilozeneSoubory
                                                                                        ? prilozeneSoubory
                                                                                        : [])
                                                                                ].filter(
                                                                                    u => u.tempnazev !== file.fileName
                                                                                );
                                                                                setPrilozeneSoubory(pv => {
                                                                                    let state = pv ? [...pv] : [];
                                                                                    state = newSoubory;
                                                                                    //  onFinish(form.getFieldsValue(), state);
                                                                                    return state;
                                                                                });
                                                                            }
                                                                        },
                                                                        onDownload: (file: UploadFile) =>
                                                                            prepareFile(
                                                                                file.fileName ? file.fileName : '',
                                                                                lei?.idVarsymZadosti?.varsym || ''
                                                                            ).then(resp => {
                                                                                fileDownload(
                                                                                    resp.redirect,
                                                                                    file.name ? file.name : 'file'
                                                                                );
                                                                            }),
                                                                        fileList: fileList.length ? fileList : [],
                                                                        buttonDisabled: fileList.length
                                                                            ? fileList.length > 4
                                                                            : false
                                                                    }}
                                                                    accept={'.pdf, .rtf, .docx, .doc'}
                                                                />
                                                            )}
                                                        </div>
                                                    </Form.Item>
                                                    {selectedEvent.eventtype === EEventType.CHANGE_LEGAL_ADDRESS && (
                                                        <Form.Item
                                                            style={{
                                                                marginBottom: 8,
                                                                fontWeight: 600
                                                            }}
                                                            name="hqsame"
                                                            label={
                                                                <TranslateText>
                                                                    LEI_AKTUALIZACE_SIDLO_CENTRAL_SAME
                                                                </TranslateText>
                                                            }
                                                            valuePropName="checked"
                                                        >
                                                            <Checkbox
                                                                disabled={isPrehled}
                                                                style={{
                                                                    position: 'relative',
                                                                    top: -10
                                                                }}
                                                                onChange={() => rerender()}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                            </FormWrapper>
                        </>
                    )}
                </>
            </Modal>
            <Modal
                open={!!openModal}
                onCancel={() => setOpenModal('')}
                footer={
                    <Row className="button-row-modal">
                        <ButtonComponent
                            onClick={() => {
                                setOpenModal('');
                                openModal === 'name'
                                    ? ((setCurrentEvents(pv => [
                                          ...(pv ? pv : []),
                                          {
                                              idzadosti: lei?.idVarsymZadosti?.id || 0,
                                              eventtype: EEventType.CHANGE_LEGAL_NAME,
                                              soubory: [],
                                              datumzmeny: ''
                                          }
                                      ]),
                                      setFileList([])),
                                      setSelectedEvent({
                                          idzadosti: lei?.idVarsymZadosti?.id || 0,
                                          eventtype: EEventType.CHANGE_LEGAL_NAME,
                                          soubory: [],
                                          datumzmeny: ''
                                      }),
                                      setSelectedEventIndex(formData?.events?.length || 0))
                                    : (setCurrentEvents(pv => [
                                          ...(pv ? pv : []),
                                          {
                                              idzadosti: lei?.idVarsymZadosti?.id || 0,
                                              soubory: [],
                                              datumzmeny: ''
                                          }
                                      ]),
                                      setFileList([]),
                                      setSelectedEvent({
                                          eventtype: EEventType.OSTATNI,
                                          idzadosti: lei?.idVarsymZadosti?.id || 0,
                                          soubory: [],
                                          datumzmeny: ''
                                      }),
                                      setSelectedEventIndex(formData?.events?.length || 0));
                            }}
                            buttontext="ANO"
                            id="leiModalAnoBtn"
                        />
                        <ButtonComponent
                            onClick={() => {
                                setOpenModal('');
                            }}
                            buttontext="NE"
                            id="leiModalNeBtn"
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph
                        text={openModal === 'ico' ? 'LEI_AKTUALIZACE_ZMENA_IC' : 'LEI_AKTUALIZACE_ZMENA_NAZVU'}
                    />
                </Row>
            </Modal>
        </>
    );
};

export default UpravaLeiDetail;
